import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Recommendation } from '../types';

interface ActionCardProps {
  recommendation: Recommendation;
  onNavigate?: () => void;
}

const ActionCard: FC<ActionCardProps> = ({ recommendation, onNavigate }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (recommendation.href) {
      navigate(recommendation.href);
      onNavigate?.();
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={!recommendation.href}
      className="w-full text-left mt-2.5 p-3.5 bg-gradient-to-br from-orange/10 to-orange/5 dark:from-teal-500/15 dark:to-teal-500/5 hover:from-orange/15 hover:to-orange/10 dark:hover:from-teal-500/20 dark:hover:to-teal-500/10 rounded-xl border border-orange/20 dark:border-teal-500/30 transition-all duration-200 group disabled:cursor-default disabled:hover:from-orange/10 disabled:hover:to-orange/5"
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <span className="font-semibold text-gray-800 dark:text-white text-sm">{recommendation.title}</span>
          {recommendation.description && (
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1 leading-relaxed">
              {recommendation.description}
            </p>
          )}
        </div>
        {recommendation.href && (
          <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-orange/10 dark:bg-teal-500/20 flex items-center justify-center ml-3 group-hover:bg-orange/20 dark:group-hover:bg-teal-500/30 transition-colors">
            <svg
              className="w-4 h-4 text-orange dark:text-teal-400 group-hover:translate-x-0.5 transition-transform"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        )}
      </div>
    </button>
  );
};

export default ActionCard;
